import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3300;
  background: rgba(8, 18, 30, 0.45);
  display: flex;
  justify-content: flex-end;
`;

export const Panel = styled.section`
  width: 620px;
  max-width: 98vw;
  height: 100%;
  max-height: 100dvh;
  background: ${ColorV2.Blue7};
  box-shadow: -12px 0 32px rgba(15, 42, 64, 0.2);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 24px 20px;
  overflow: hidden;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
  padding-left: 24px;
`;

export const WorkerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const AvatarCircle = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: ${ColorV2.Blue6};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const NameBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Name = styled.h2`
  ${TypographyV2.h2}
  color: ${ColorV2.Blue1};
  margin: 0;
`;

export const MetaRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const MetaTooltipContent = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue3};
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const CloseButton = styled(SecondaryButton)`
  flex-shrink: 0;
  align-self: flex-end;
`;

export const LockedEditButton = styled(SecondaryButton)`
  & svg {
    width: 12px !important;
    height: 12px !important;
  }
`;

export const LockedEditWrap = styled.div`
  position: relative;
  display: inline-flex;
`;

export const LockedEditTooltip = styled.div`
  position: absolute;
  left: 50%;
  bottom: calc(100% + 10px);
  transform: translateX(-50%);
  z-index: 2;
  pointer-events: none;
`;

export const WarningBanner = styled.div`
  background: ${ColorV2.OfferedYellow};
  border-radius: 12px;
  padding: 12px 14px;
  color: ${ColorV2.Blue1};
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const WarningTitle = styled.p`
  ${TypographyV2.b1}
  margin: 0;
`;

export const WarningBody = styled.p`
  ${TypographyV2.s1}
  margin: 0;
`;

export const UpcomingEmploymentBanner = styled(WarningBanner)`
  background: ${ColorV2.UnplannedAbsenceYellow};
`;

export const UpcomingEmploymentBannerBody = styled(WarningBody)`
  color: ${ColorV2.DarkAmbigiousYellow};
`;

export const NoEmploymentBanner = styled(WarningBanner)`
  background: #d4dbe0;
`;

export const NoEmploymentBannerBody = styled(WarningBody)`
  color: ${ColorV2.Blue3};
`;

export const TabsRow = styled.div`
  display: flex;
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding-right: 8px;
  margin-right: -8px;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  ${TypographyV2.h5}
  margin: 0;
  color: ${ColorV2.Blue1};
`;

export const SectionActionRow = styled.div`
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
`;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 22px;

  @media (max-width: 700px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 520px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FieldCard = styled.div`
  background: transparent;
  border-radius: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-height: 52px;
`;

export const SectionBox = styled.div`
  background: ${ColorV2.White};
  border-radius: 12px;
  padding: 14px 16px;
`;

export const FieldValue = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  word-break: break-word;
`;

export const StatValueRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const FieldLabel = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const Message = styled.div`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue4};
  padding: 6px 0;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  padding-top: 8px;
`;
